import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import { EmployeeAvatar } from '../../../common/EmployeeAvatar';
import { COLORS } from '../../../../constants/radar';

const getActiveStatusStyles = (isActive) => {
  if (isActive) {
    return {
      backgroundColor: '#E6F4EA',
      color: '#1E8E3E',
      label: 'Active'
    };
  }
  return {
    backgroundColor: '#F3F4F6',
    color: '#6B7280',
    label: 'Inactive'
  };
};

const QualifyingConsultantCard = ({ consultant }) => {
  const isActive = consultant.isActive !== false;
  const statusStyles = getActiveStatusStyles(isActive);

  const positionGrade = [
    consultant.position?.label,
    consultant.grade?.label
  ].filter(Boolean).join(' \u2022 ') || 'No position assigned';

  return (
    <Box
      sx={{
        backgroundColor: '#f8f9fa',
        borderRadius: '4px',
        border: '1px solid #e0e0e0',
        padding: '16px',
        height: '100%',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        transition: 'all 0.2s',
        overflow: 'hidden',
        '&:hover': {
          backgroundColor: '#f1f3f5',
          borderColor: '#bdbdbd',
          boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
        }
      }}
    >
      <Box sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        gap: '12px'
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px', flex: 1, minWidth: 0 }}>
          <EmployeeAvatar employee={consultant} size={40} />
          <Typography
            sx={{
              fontSize: '16px',
              fontWeight: 500,
              color: COLORS.PRIMARY,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}
          >
            {consultant.fullName}
          </Typography>
        </Box>

        <Chip
          label={statusStyles.label}
          size="small"
          sx={{
            backgroundColor: statusStyles.backgroundColor,
            color: statusStyles.color,
            fontWeight: 500,
            fontSize: '12px',
            height: '24px',
            flexShrink: 0
          }}
        />
      </Box>

      <Typography
        sx={{
          fontSize: '14px',
          color: '#64748B',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap'
        }}
      >
        {positionGrade}
      </Typography>
    </Box>
  );
};

export default QualifyingConsultantCard;
